module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader",
    class: {
      loaderAnimationIn: _vm.show
    },
    attrs: {
      "id": "modal-loader"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "loader-contents"
  }, [_c('h2', {
    staticClass: "loader-title"
  }, [_vm._v(_vm._s(_vm.$t('heading.title')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('heading.message')))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader-bar"
  }, [_c('div', {
    staticClass: "bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "bar"
  }), _vm._v(" "), _c('div', {
    staticClass: "bar"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31fe3e73"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/loader/loader.vue
// module id = 295
// module chunks = 0